<template>
  <b-card no-body class="h-100">
    <b-card-header>
      <b-card-title class="mb-50"><h4>کاربران</h4> </b-card-title>
    </b-card-header>
    <b-card-body> 
      <div v-if="!students">
        <b-skeleton width="100%" height="280px" />
      </div>
      <vue-apex-charts
         v-else
        type="bar"
        height="300" 
        :options="columnChart.chartOptions"
        :series="columnChart.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BSkeleton,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts"; 
import { $themeColors } from '@themeConfig';

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    VueApexCharts,
    BCardTitle,
    BSkeleton,
  },
  data() {
    return {
      columnChart: {
        series: [
          {
            name: "کاربران ",
            data: [],
          },
          {
            name: "کاربران یونیک",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          colors: [$themeColors.primary, $themeColors.info],
          plotOptions: {
            bar: {
              columnWidth: "30%", 
              borderRadius: 3,
            },
          },
          dataLabels: {
            enabled: true,
          },
          legend: {
            show: true,
            position: "top",
            fontSize: "14px",
            fontFamily: "Montserrat",
            horizontalAlign: "left",
          },
          stroke: {
            show: false,
            colors: ["transparent"],
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
             padding: {
              bottom: -35, 
            },
          },
          xaxis: {
            categories: [this.$route.params.id],
          },
          yaxis: {
            opposite: true,
          },
          fill: {
            opacity: 1,
          },
        },
      },
      users: {},
      loading: false,
    };
  },
  props: {
    students: {
      type: Number,
      default: 0,
    },
    unic_students: {
      type: Number,
      default: 0,
    },
  },
  watch:{
    students(val){
      this.columnChart.series[0].data[0] = val;
    },
    unic_students(val){
      this.columnChart.series[1].data[0] = val;
    }
  }
};
</script>
